module.exports = __webpack_public_path__ + "static/media/calm_happy.f64cd347.svg";